<template>
  <div>
   <ResalePropertyListComp />
  </div>
</template>

<script>
import ResalePropertyListComp from '../../../../components/tax/delinquent/juneResale/ResalePropertyList/ResalePropertyList.vue';

export default {
  name: 'ResalePropertyList',
  components: {
    ResalePropertyListComp,
  },
};
</script>
